module.exports = __webpack_public_path__ + "img/d8f1dd7312fe8ef1020fe440ffeee9bf.edc80c51.png";